import React from 'react';
import { cx } from '@emotion/css';
import { CheckMark } from '../../atoms';
import { useWizardNavEntryStyles } from './WizardNavEntry.styles';
export function WizardNavEntry(props) {
    const styles = useWizardNavEntryStyles(props);
    const handleClick = () => {
        props.onClick();
    };
    return (React.createElement("button", { className: cx(props.className, styles.container), id: props.id, onClick: handleClick, disabled: props.disabled },
        React.createElement(CheckMark, { checked: props.completed }),
        React.createElement("div", { className: cx(styles.text, {
                [styles.active]: props.active,
                [styles.inactive]: !props.active,
            }) }, props.text)));
}
//# sourceMappingURL=WizardNavEntry.js.map